import { connect } from 'react-redux'
import GenericError from './generic-error'
import { getErrorRef } from '../../redux/magic-links.selectors'

const mapStateToProps = state => ({
  errorRef: getErrorRef(state)
})

export default connect(
  mapStateToProps,
  null
)(GenericError)
